import React, { lazy } from 'react';
import { Route, Navigate } from 'react-router-dom';

const ShopifyListingTabs = lazy(() => import('../components/shopify/create-listing/ShopifyListingTabs'));
const ShopifyEditListing = lazy(() => import('../components/shopify/edit-listing/ShopifyEditListing'));

export const shopifyRoutes = (
  <>
    <Route path="/shopify-listing" element={<Navigate to="/shopify-create" replace />} />
    <Route path="/shopify-create" element={<ShopifyListingTabs />} />
    <Route path="/shopify-us-create" element={<Navigate to="/shopify-create?market=us" replace />} />
    <Route path="/shopify-edit" element={<ShopifyEditListing />} />
    <Route path="/shopify" element={<Navigate to="/shopify-create" replace />} />
  </>
);
